import api from "../../api";
import { getCoordinateObject, getVisibility } from "../../utils";
import { collectionSubAdapter } from "../collection/adapter";
import adapterJoinRequests from "../join-requests/adapter"
import systemAdapter from '../system/adapter'

const subAdapter = {
  member: {
    responseBodyToRender(input = []){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const element = input[index];
          const { individu } = element

          output.push({
            id: individu.userId,
            name: individu.namaIndividu,
            photo: api.base_image+individu.imgFotoProfile
          })
        }
      }

      return output
    },
    responseBodyToTable(member, joinRequests){
      let result = []

      if(joinRequests && joinRequests.length > 0){
        for (let index = 0; index < joinRequests.length; index++) {
          const request = joinRequests[index];

          result.push({
            meta: {
              requestId: request.id,
              statusId: request.statusRequest?.id
            },
            id: request.individu?.userId,
            name: request.individu?.namaIndividu,
            image: api.base_image+request.individu?.imgFotoProfile,
            role: '-',
            status: 'Ask to join',
            // status: request.statusRequest?.nama?.[0]
          })
        }
      }

      return result
    },
    responseBodyToOptions(input = []){
      let output = []

      if(input && input.length > 0){
        for (let index = 0; index < input.length; index++) {
          const element = input[index];
          const { individu } = element

          output.push({
            value: individu.userId,
            label: individu.namaIndividu,
          })
        }
      }

      return output
    }
  },
  milestone: {
    responseBodyToRender(input){
      let output
      if(input){
        output = {
          id: input.pkMilestoneId,
          year: input.tahun,
          description_id: input.deskripsi[0],
          description_en: input.deskripsi[1],
          description: {
            en: input.deskripsi[1],
            id: input.deskripsi[0]
          }
        }
      }
      return output
    },
    formToRequestBody(input){
      let output

      if(input){
        output = {
          tahun: input.year,
          deskripsi: [
            input.description_id,
            input.description_en
          ]
        }
      }

      return output
    }
  },
  social_link: {
    responseBodyToRender(input){
      let output
      if(input){
        const category = input.kategoriSosialMedia
        const name = category.nama ? category.nama[0].toLowerCase() : category

        output = {
          id: input.pkSosialMediaId,
          name,
          link: input.linkSosialMedia
        }
      }
      return output
    }
  },
  programs: {
    responseBodyToRender(input = []){
      let output = []

      if(input && input.length > 0){
        output = input.map(program => {
          const {
            programId,
            judulActivity,
            imgThumbnail,
            statusActivity,
            tanggalMulai,
            tanggalSelesai,
            deskripsiPendek = []
          } = program

          return {
            id: programId,
            thumbnail: api.base_image+imgThumbnail,
            title: {
              en: judulActivity[1],
              id: judulActivity[0]
            },
            status: {
              en: statusActivity?.nama[1],
              id: statusActivity?.nama[0]
            },
            start_date: tanggalMulai,
            end_date: tanggalSelesai,
            description: {
              en: deskripsiPendek[1],
              id: deskripsiPendek[0]
            }
          }
        })
      }

      return output
    },
    responseBodyToOptions(input = []){
      let output = []

      if(input && input.length > 0){
        output = input.map(program => {
          return {
            label: program.judulActivity[0],
            value: program.programId
          }
        })
      }

      return output
    }
  },
  events: {
    responseBodyToOptions(input = []){
      let output = []

      if(input && input.length > 0){
        output = input.map(event => {
          return {
            label: event.judulActivity[0],
            value: event.eventId
          }
        })
      }

      return output
    }
  },
  resources: {
    responseBodyToOptions(input = []){
      let output = []

      if(input && input.length > 0){
        output = input.map(resource => {
          return {
            label: resource.judulArtikel[0],
            value: resource.resourceId
          }
        })
      }

      return output
    }
  },
  blog: {
    responseBodyToOptions(input = []){
      let output = []

      if(input && input.length > 0){
        output = input.map(blog => {
          return {
            label: blog.judulArtikel[0],
            value: blog.blogId
          }
        })
      }

      return output
    }
  },
  branch: {
    responseBodyToRender(input){
      let output = {}

      if(input){
        const {
          imgLogoOrganisasi,
          namaOrganisasi,
          organisasiId
        } = input

        output = {
          id: organisasiId,
          name: namaOrganisasi,
          image: api.base_image+imgLogoOrganisasi,
        }
      }

      return output
    }
  },
  partner: {
    responseBodyToRender(input = {}){
      let output = {}

      if(input){
        const {
          pkPartnerInternalId,
          partner = {
            organisasiId: undefined,
            namaOrganisasi: undefined,
            imgLogoOrganisasi: undefined,
            websiteOrganisasi: undefined
          }
        } = input
        output = {
          pkId: pkPartnerInternalId,
          id: partner.organisasiId,
          name: partner.namaOrganisasi,
          image: api.base_image+partner.imgLogoOrganisasi,
          website: partner.websiteOrganisasi
        }
      }

      return output
    }
  }
}

const adapter = {
  responseBodyToRender(input){
    let output = {}

    if(input){
      const {
        highlight,
        deskripsi,
        lokasiOrganisasi = [],
        organisasiId,
        namaOrganisasi,
        imgMainImage,
        imgLogoOrganisasi,
        statusVerification,
        institutionProfile,
        teamMember = [],
        typeOrganisasi = [],
        tahunBerdiri,
        typeApproach = [],
        typeIssues = [],
        emailOrganisasi,
        teleponOrganisasi,
        milestoneOrganisasi = [],
        sosialMedia = [],
        requestedByIndividu = [],
        websiteOrganisasi,
        totalMember,
        binInstitutionProfile,
        createdAt,
        featuredContent = {},
        pendingBranchRequested = [],
        pendingBranchInvitations = [],
        headquarter,
        organisasiCabangInternal = [],
        tampilan,
        totalLikes,
        listLike = [],
        partnerOrganisasiInternal = [],
        partnerOrganisasiEksternal = [],
        visibilityDefault = [],
        bookmarkByMe,
        likedByMe
      } = input

      const highlightAvailable = highlight && highlight !== null
      const descriptionAvailable = deskripsi && deskripsi !== null
      const lokasi = lokasiOrganisasi
      const location = lokasi && lokasi[0] ? `${lokasi[0].kota}, ${lokasi[0].provinsi}` : '-'
      const address = lokasi && lokasi[0] ? `${lokasi[0].jalan}` : '-'

      // members: individu yang sudah approved jadi anggota organisasi
      const members = teamMember ? teamMember.map(m => {
        return {
          joinId: m.pkJoinedOrganizationId,
          id: m.individu ? m.individu.userId : '',
          name: m.individu ? m.individu.namaIndividu : '',
          image: m.individu ? api.base_image+m.individu.imgFotoProfile : '',
          status: 'Joined',
          role: '-',
        }
      }) : []

      const members_options = members.map(org => {
        return {
          value: org.id,
          label: org.name
        }
      })

      // requests: permintaan bergabung dengan organisasi dari individu
      const requests = requestedByIndividu.map(r => adapterJoinRequests.responseBodyToOrganizationForm(r))

      // member_table_data: gabungan dari "members" dan "requests" untuk ditampilkan pada table
      const member_table_data = subAdapter.member.responseBodyToTable(teamMember, requestedByIndividu)

      // branch_invitations_sent: permintaan untuk bergabung menjadi branch, yang dikirim kepada organisasi lain
      const branch_invitations_sent = pendingBranchRequested.map(i => subAdapter.branch.responseBodyToRender(i))

      // branch_invitations_received: permintaan untuk bergabung menjadi branch, yang dikirim oleh organisasi lain
      const branch_invitations_received = pendingBranchInvitations.map(i => subAdapter.branch.responseBodyToRender(i))

      const branches = organisasiCabangInternal.map(i => subAdapter.branch.responseBodyToRender(i))

      const visibility_field_blacklist = [
        'vsbTypeAudiance',
        'vsbTotalMember',
        'vsbPartnerOrganisasiInternal',
        'vsbHighlight',
        'vsbDeskripsi',
        'vsbMissionStatement',
        'vsbTbOrganisasiPartnerEksternal'
      ]
      const visibility_id_only = getVisibility(input, visibility_field_blacklist).visibilityIdOnly

      const pin_points = lokasiOrganisasi
        .filter(l => getCoordinateObject(l.pinLocation))
        .map((l, index) => {
          return {
            name: namaOrganisasi,
            id: namaOrganisasi+index,
            type: 'place',
            coordinate: getCoordinateObject(l.pinLocation),
            // markerType options: 'headquarter' or 'place'
            markerType: 'place',
            content: `<div class="border-b border-solid mb-2 pb-2">${namaOrganisasi}</div><p>${l.jalan}, ${l.kota}, ${l.provinsi} ${l.kodePos || ''}</p>`,
          }
        })

      output = {
        id: organisasiId,
        created_at: createdAt,
        organizationId: organisasiId,
        name: namaOrganisasi,
        logo: api.base_image+imgLogoOrganisasi,
        image: api.base_image+imgMainImage,
        highlight_id: highlightAvailable ? highlight[0] : '',
        highlight_en: highlightAvailable ? highlight[1] : '',
        highlight: highlightAvailable ? {
          id: highlight[0],
          en: highlight[1]
        } : {
          id: undefined,
          en: undefined
        },
        description_id: descriptionAvailable ? deskripsi[0] : '',
        description_en: descriptionAvailable ? deskripsi[1] : '',
        description: descriptionAvailable ? {
          id: deskripsi[0],
          en: deskripsi[1]
        } : {
          id: undefined,
          en: undefined
        },
        status: statusVerification,
        institution: institutionProfile,
        types: typeOrganisasi,
        type_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeOrganisasi),
        since: tahunBerdiri,
        approaches: typeApproach,
        approach_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeApproach),
        location,
        address,
        issues: typeIssues,
        issue_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeIssues),
        email: emailOrganisasi,
        phone: teleponOrganisasi,
        background_color: tampilan,

        milestones: milestoneOrganisasi.map(m => subAdapter.milestone.responseBodyToRender(m)),
        socialLinks: sosialMedia.map(s => subAdapter.social_link.responseBodyToRender(s)),

        requests,
        members,
        members_options,
        member_table_data,
        website: websiteOrganisasi,
        profile: api.base_image+binInstitutionProfile,

        // Map Section Statistics
        total_member: teamMember ? teamMember.length : totalMember,
        total_cities: lokasiOrganisasi ? lokasiOrganisasi.length : 0,
        total_team: 0,
        total_activity: 0,
        total_program: 0,
        total_event: 0,
        total_partners: partnerOrganisasiInternal.length + partnerOrganisasiEksternal.length,

        // Map Data
        pin_points,

        featured_programs: subAdapter.programs.responseBodyToRender(featuredContent.featuredProgram),
        featured_programs_options: subAdapter.programs.responseBodyToOptions(featuredContent.featuredProgram),
        featured_events: [],
        featured_events_options: subAdapter.events.responseBodyToOptions(featuredContent.featuredEvent),
        featured_resources: [],
        featured_resources_options: subAdapter.resources.responseBodyToOptions(featuredContent.featuredResource),
        featured_blog: [],
        featured_blog_options: subAdapter.blog.responseBodyToOptions(featuredContent.featuredBlog),

        // Branches
        branch_invitations_sent,
        branch_invitations_received,
        headquarter: {
          name: headquarter?.namaOrganisasi,
          id: headquarter?.organisasiId
        },
        branches,
        is_headquarter: branches && branches.length > 0,
        total_branches: branches.length,

        total_likes: totalLikes,
        likes: listLike.map(l => collectionSubAdapter.like.responseBodyToRender(l)),

        // Partners
        partners: partnerOrganisasiInternal.map(p => subAdapter.partner.responseBodyToRender(p)),
        partners_external: partnerOrganisasiEksternal.map(p => {
          return {
            pkId: p.pkPartnerEksternalId,
            id: p.systemRowId,
            name: p.namaPartner,
            image: api.base_image+p.imgLogoPartner,
            website: p.websitePartner
          }
        }),

        visibilityDefault: visibilityDefault[0] ? visibilityDefault[0] : {},
        visibility_id_only,

        bookmarked: bookmarkByMe,
        liked: likedByMe
      }
    }

    return output
  },
  responseBodyToProgramForm(input){
    let output

    if(input){
      const {
        teamMember = []
      } = input

      output = {
        members: teamMember.map(t => {
          return {
            id: t.individu.userId,
            name: t.individu.namaIndividu,
            image: api.base_image+t.individu.imgFotoProfile
          }
        }),
        members_options: teamMember.map(t => {
          return {
            label: t.individu.namaIndividu,
            value: t.individu.userId
          }
        })
      }
    }

    return output
  }
}

export { subAdapter }
export default adapter
